<template>
  <div>
    <v-navigation-drawer v-model="drawer" app clipped>
      <v-img :aspect-ratio="2/1" src="https://www.salondeck.com/images/salondeck.jpg">
        <!-- src="https://cdn.vuetifyjs.com/images/parallax/material.jpg" -->
        <!-- <v-layout pa-2 column fill-height class="lightbox white--text">
          <v-spacer></v-spacer>
          <v-flex shrink text-xs-right>
            <div class="subheading">{{loggedInUserName}}</div> 
            <div class="body-1">{{email}}</div>
          </v-flex>
        </v-layout>-->
      </v-img>

      <v-list dense>
        <template v-for="(item, i) in menuItems">
          <template v-if="item.visible">
            <v-divider v-if="item.divider" :key="i"></v-divider>
            <v-list-item v-else :key="item.text" @click="OpenDialog(item.dialog)">
              <v-list-item-action>
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-action>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item>
          </template>
        </template>
      </v-list>

      <!-- <v-list dense>
          <v-list-item v-for="item in items" :key="item.text" link>
            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>{{ item.text }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-subheader class="mt-4 grey--text text--darken-1">SUBSCRIPTIONS</v-subheader>
          <v-list>
            <v-list-item v-for="item in items2" :key="item.text" link>
              <v-list-item-avatar>
                <img
                  :src="
                    `https://randomuser.me/api/portraits/men/${item.picture}.jpg`
                  "
                  alt
                />
              </v-list-item-avatar>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item>
          </v-list>
          <v-list-item class="mt-4" link>
            <v-list-item-action>
              <v-icon color="grey darken-1">mdi-plus-circle-outline</v-icon>
            </v-list-item-action>
            <v-list-item-title class="grey--text text--darken-1">Browse Channels</v-list-item-title>
          </v-list-item>
          <v-list-item link>
            <v-list-item-action>
              <v-icon color="grey darken-1">mdi-settings</v-icon>
            </v-list-item-action>
            <v-list-item-title class="grey--text text--darken-1">Manage Subscriptions</v-list-item-title>
          </v-list-item>
      </v-list>-->
    </v-navigation-drawer>

    <v-app-bar app clipped-left color="primary" dense dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      <!-- <v-icon class="mx-4" large>
            mdi-youtube
          </v-icon>
          <v-toolbar-title class="mr-12 align-center">
            <span class="title">Salondeck</span>


            
      </v-toolbar-title>-->
      <v-spacer></v-spacer>
      <v-row align="center" style="max-width: 650px">
        <v-autocomplete
          @input="showSelectedClienDialog()"
          v-model="client"
          :items="items"
          :loading="isLoading"
          :search-input.sync="search"
          chips
          clearable
          hide-details
          item-text="name"
          item-value="id"
          label="Search client..."
          solo
          light
          dense
          return-object
        >
          <template v-slot:no-data>
            <v-list-item>
              <v-list-item-title>Type client's name</v-list-item-title>
            </v-list-item>
          </template>
          <template v-slot:selection="{ item }">
            <span v-text="item.name"></span>
          </template>
          <template v-slot:item="{ item }">
            <v-list-item-avatar
              color="primary"
              class="headline font-weight-light white--text"
            >{{ item.name.charAt(0) }}</v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.name"></v-list-item-title>
            </v-list-item-content>
          </template>

          <!-- <v-chip
            :selected="selected"
            :color=color
            class="white--text"
          >
          <v-icon left>mdi-coin</v-icon>-->

          <!-- </v-chip> -->

          <!-- <template slot="item" slot-scope="{ item }">
            <v-list-title-avatar color="primary" class="headline font-weight-light white--text">
              <div style="margin:0 auto">{{ item.name.charAt(0) }}</div>
            </v-list-title-avatar>
            <v-list-title-content>
              <v-list-title-title v-text="item.name"></v-list-title-title>
            </v-list-title-content>
          </template>-->
        </v-autocomplete>
      </v-row>
    </v-app-bar>

    <UserSettingDialog ref="UserSettingDialog"></UserSettingDialog>
    <client-upload-dialog ref="UploadClientDialog"></client-upload-dialog>
    <logout-dialog ref="LogoutDialog" v-on:Logout="LogOut()"></logout-dialog>
    <ServiceManagerDialog ref="ServicesDialog" v-on:DeleteService="OpenDeleteServiceDialog"></ServiceManagerDialog>
    <company-settings-dialog ref="CompanySettingsDialog"></company-settings-dialog>
    <reports-dialog ref="ReportsDialog"></reports-dialog>
    <users-and-roles-dialog ref="UsersAndRolesDialog"></users-and-roles-dialog>
    <client-detail-dialog ref="ClientDetailDialog" v-on:AfterClosingDilaog="ClearCombo"></client-detail-dialog>
    <!-- 
    
    
    
    <add-client-dialog ref="AddClientDialog"></add-client-dialog>
    
    -->
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "SideMenu",
  components: {
    UsersAndRolesDialog: () => import("../dialogs/UsersAndRolesDialog.vue"),
    CompanySettingsDialog: () => import("../dialogs/CompanySettingsDialog.vue"),
    ServiceManagerDialog: () => import("../dialogs/ServicesDialog.vue"),
    UserSettingDialog: () => import("../dialogs/UserSettings.vue"),
    // DeleteServiceDialog: () => import('./Dialogs/DeleteServiceDialog.vue'),
    ClientDetailDialog: () => import("../dialogs/ClientDetailDialog.vue"),
    LogoutDialog: () => import("../dialogs/LogoutDialog.vue"),
    // AddClientDialog: () => import('./../Schedule/AddClientDialog.vue'),
    ClientUploadDialog: () => import("../dialogs/ClientUpload.vue"),
    ReportsDialog: () => import("../dialogs/ReportsDialog.vue")
  },
  created() {
    //this.getUserRoles();
  },
  mounted() {
    this.SetVisiblityByRoles();
  },
  data: () => ({
    drawer: null,
    fab: null,
    isLoading: false,
    items: [],
    search: null,
    client: null,
    clientDialog: false,
    users: [],
    SelectedUser: null,
    menuItems: [
      {
        icon: "mdi-account",
        text: "Account",
        dialog: "portal",
        visible: false,
        roleCode: "CMCA"
      },
      {
        icon: "mdi-account-multiple",
        text: "Users & Roles",
        dialog: "UsersAndRolesDialog",
        visible: false,
        roleCode: "CMEA"
      },
      {
        icon: "mdi-face",
        text: "User settings",
        dialog: "UserSettingDialog",
        visible: true
      },
      {
        icon: "mdi-cloud-upload",
        text: "Client Upload",
        dialog: "UploadClientDialog",
        visible: true
      },
      { divider: true, visible: true },

      {
        icon: "mdi-wrench",
        text: "Services",
        dialog: "ServicesDialog",
        visible: false,
        roleCode: "CMS"
      },
      {
        icon: "mdi-cog",
        text: "Company settings",
        dialog: "CompanySettingsDialog",
        visible: false,
        roleCode: "CMCS"
      },

      {
        icon: "mdi-chart-areaspline-variant",
        text: "Reports",
        dialog: "ReportsDialog",
        visible: false,
        roleCode: "CMCA"
      },
      { divider: true, visible: true },
      {
        icon: "mdi-power",
        text: "Log out",
        dialog: "LogoutDialog",
        visible: true
      }
    ]
  }),
  methods: {
    SetVisiblityByRoles() {
      const grouproles = this.$store.getters.user.details.grouprole;
      const roles = [];
      grouproles.forEach(gr => {
        roles.push(gr.roles);
      });
      this.menuItems.forEach(mi => {
        if (mi.roleCode) {
          let ur = roles.find(r => r.roleCode == mi.roleCode);
          if (ur) {
            mi.visible = true;
          }
        }
      });
    },

    getUserRoles() {
      let queryString = `query userDetails2($email:String!){
                          userDetails2(email: $email){
                          id
                          firstname
                          lastname
                          companyId
                          emailAddress
                          phoneNumber
                          group{
                            groupName
                          }
                          grouprole{
                            roles{
                              roleCode
                            }
                          }
                        }
                      }`;
      axios
        .post("/graphql", {
          query: queryString,
          variables: {
            email: this.$store.getters.user.email
          }
        })
        .then(result => {
          let loggedInUser = this.$store.getters.user;
          loggedInUser.details = result.data.data.userDetails2;
          this.$store.dispatch("setUser", loggedInUser);
          return;
        })
        .then(() => {
          this.SetVisiblityByRoles();
        })
        .catch(error => {
          this.showError(error.message);
        });
    },

    OpenDialog(dialog) {
      if (dialog === "UserSettingDialog") {
        this.OpenUserSettingsDialog();
      } else if (dialog === "LogoutDialog") {
        this.OpenLogOutDialog();
      } else if (dialog === "ServicesDialog") {
        this.OpenServicesDialog();
      } else if (dialog === "CompanySettingsDialog") {
        this.OpenCompanySettingsDialog();
      } else if (dialog === "UsersAndRolesDialog") {
        this.OpenUsersAndRolesDialog();
      } else if (dialog === "portal") {
        this.Startportal();
      } else if (dialog === "AddClientDialog") {
        this.OpenAddClientDialog();
      } else if (dialog === "UploadClientDialog") {
        this.OpenClientUploadDialog();
      } else if (dialog === "ReportsDialog") {
        this.OpenReportsDialog();
      } else {
        dialog = true;
      }
    },
    GetServices() {
      this.$refs.ServicesDialog.GetCompanyServices();
    },
    OpenDeleteServiceDialog(currentService) {
      this.$refs.DeleteServiceDialog.OpenDialog(currentService);
    },
    OpenServicesDialog() {
      this.$refs.ServicesDialog.OpenDialog();
    },
    OpenUserSettingsDialog() {
      this.$refs.UserSettingDialog.OpenDialog();
    },
    OpenLogOutDialog() {
      this.$refs.LogoutDialog.OpenDialog();
    },
    OpenCompanySettingsDialog() {
      this.$refs.CompanySettingsDialog.OpenDialog();
    },
    OpenUsersAndRolesDialog() {
      this.$refs.UsersAndRolesDialog.OpenDialog();
    },
    OpenAddClientDialog() {
      this.$refs.AddClientDialog.Open();
    },
    OpenClientUploadDialog() {
      this.$refs.UploadClientDialog.OpenDialog();
    },
    OpenReportsDialog() {
      this.$refs.ReportsDialog.OpenDialog();
    },
    Startportal() {
      let chargebeeInstance = window.Chargebee.init({
        site: "hairpointments-test"
      });

      //let chargebeeInstance = cbInstance.getInstance();
      const companyId = this.$store.getters.user.details.companyId;

      chargebeeInstance.setPortalSession(function() {
        return axios
          .post("api/create_portal_session", { id: companyId })
          .then(response => response.data);
      });
      let cbPortal = chargebeeInstance.createChargebeePortal();
      cbPortal.open({
        subscriptionChanged: function(data) {
          console.log(data);
        },
        close() {
          chargebeeInstance.logout();
        }
      });
    },

    showSelectedClienDialog() {
      if (this.client) {
        this.$refs.ClientDetailDialog.client = this.client;
        this.$refs.ClientDetailDialog.OpenDialog();
      }
    },
    ClearCombo() {
      this.client = null;
      this.items = [];
    }
  },
  computed: {
    //   loggedInUserName() {
    //   return this.$store.getters.user.firstname;
    // },
    // email() {
    //   return this.$store.getters.user.emailAddress;
    // },
  },
  watch: {
    client() {
      if (this.client != null) this.clientDialog = true;
      else this.clientDialog = false;
    },
    search(val) {
      if (val.length < 3) return;
      // Items have already been loaded
      if (this.items.length > 0) return;

      this.isLoading = true;

      // Lazily load input items
      let querystring = `
            query clients2( $companyId: String!){
                clients2(companyId:$companyId, ){
                  id,
                name,
                phoneNumber,
                emailAddress,
                description,
                sendSMS,
                languageId,
                appointments(last:3) {
                  id,
                  startTimeStamp,
                  description
                },
                upcomingappointment{
                  id,
                  startTimeStamp,
                  description
                }
              }
            }
            `;
      axios
        .post("/graphql", {
          query: querystring,
          variables: {
            companyId: this.$store.getters.user.details.companyId
          }
        })
        .then(res => {
          this.items = res.data.data.clients2;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  }
};
</script>